import { i18n } from "@lingui/core";
import WarpElement from "@warp-ds/elements-core";
import { css, html } from "lit";
import { trackClickEvent, trackViewEvent } from "../tracking.js";
import { TrackingEventMap, eventReference } from "../../models/trackingEvent.js";
import { activateI18n } from "../../utils/i18n.js";

class PriceEvaluationBanner extends WarpElement {
    declare trackingEventMap: TrackingEventMap;
    declare href: string;
    declare illustrationUrl: string;

    static properties = {
        trackingEventMap: { type: Object },
        href: { attribute: true, type: String },
        illustrationUrl: { attribute: true, type: String },
    };

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-jaXekv;
        `,
    ];

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
        trackViewEvent(this.trackingEventMap[eventReference.PRICE_EVALUATION_BANNER_VIEW]);
    }

    render() {
        const title = i18n.t({
            id: "market-frontpage.price-advice",
            message: "Used car price tips",
        });

        const body = i18n.t({
            id: "market-frontpage.price-advice-description",
            message: "Get price estimates from similar cars sold on FINN",
        });

        const cta = i18n.t({
            id: "market-frontpage.price-evaluation-banner.cta",
            message: "Go to valuation",
        });

        return html`
            <div
                class="rounded-8 s-bg-negative-subtle py-[24px] px-[16px] md:px-[32px] flex flex-col md:flex-row md:items-center gap-16 md:gap-24"
            >
                <div class="flex items-start md:items-center gap-16 flex-1">
                    <img src="${this.illustrationUrl}" alt="" class="w-[80] h-[80] md:w-[100] md:h-[100] flex-shrink-0" />
                    <div class="flex flex-col gap-4">
                        <h3 class="t3 mb-0">${title}</h3>
                        <p class="text-body mb-0">${body}</p>
                    </div>
                </div>
                <a
                    href="${this.href}"
                    class="block flex-shrink-0"
                    @click="${() => trackClickEvent(this.trackingEventMap[eventReference.PRICE_EVALUATION_BANNER], this.href)}"
                >
                    <w-button variant="secondary" full-width>${cta}</w-button>
                </a>
            </div>
        `;
    }
}

customElements.define("price-evaluation-banner", PriceEvaluationBanner as unknown as CustomElementConstructor);
